module.exports = __webpack_public_path__ + "img/icons8-time.c51504c3.svg";